import base from './base';

const chartAPI = dispatch => {
  return {
    async getPerformanceChart(pid, period) {
      return base.privateApi(dispatch, {
        path: `/chart/index/vp/${pid}/${period}`,
        method: 'get'
      });
    },

    async getPriceHistory(code, period) {
      const response = await base.privateApi(dispatch, {
        path: `/chart/history/candle/${code}/${period}`,
        method: 'get',
      });
      return response;
    },

    async filterWatchlist(data) {
      const response = await base.privateApi(dispatch, {
        path: `/dashboard/watchlist`,
        method: 'post',
        data
      });
      return response;
    },

    async getCap2UnemploymentChart(period) {
      const response = await base.privateApi(dispatch, {
        path: `/chart/indicator/cap2Unemployment/${period}`,
        method: 'get',
      });
      return response;
    },

    async getCap2InflationChart(period) {
      const response = await base.privateApi(dispatch, {
        path: `/chart/indicator/cap2Inflation/${period}`,
        method: 'get',
      });
      return response;
    },

    async getCap2InterestChart(period) {
      const response = await base.privateApi(dispatch, {
        path: `/chart/indicator/cap2Interest/${period}`,
        method: 'get',
      });
      return response;
    },

    async getCap2GDPChart(period) {
      const response = await base.privateApi(dispatch, {
        path: `/chart/indicator/cap2GDP/${period}`,
        method: 'get',
      });
      return response;
    },

    async getBIndicator(period) {
      const response = await base.privateApi(dispatch, {
        path: `/chart/indicator/wb/${period}`,
        method: 'get',
      });
      return response;
    },

    async getIndustryComponents(industryCode) {
      const response = await base.privateApi(dispatch, {
        path: `/chart/bubble/industry/${industryCode}`,
        method: 'get',
      });
      return response;
    },

    async getIndustryIndexes(params) {
      let path = '';
      if (params.industryCode) {
        path =`/chart/history/indexes/industry/${params.period}/${params.sector}?industry=${params.industryCode}`;
      } else {
        path =`/chart/history/indexes/industry/${params.period}/${params.sector}`;
      }
      const response = await base.privateApi(dispatch, {
        path: path,
        method: 'get',
      });
      return response;
    },

    async getSectorIndexes(params) {
      let path = '';
      if (params.sector) {
        path =`/chart/history/indexes/${params.period}?sector=${params.sector}`;
      } else {
        path =`/chart/history/indexes/${params.period}`;
      }
      const response = await base.privateApi(dispatch, {
        path: path,
        method: 'get',
      });
      return response;
    },

    async getCap2BondChart(period) {
      const response = await base.privateApi(dispatch, {
        path: `/chart/indicator/cap2bond/${period}`,
        method: 'get',
      });
      return response;
    },

    async getDonutChartByType(method) {
      const response = await base.privateApi(dispatch, {
        path: `/dashboard/chart/${method}`,
        method: 'get',
      });
      return response;
    },
  };
};

export default chartAPI;
